The input parameter for the `updateUploadedCandidatePerson` mutation.
